import {Data, Func, Int, Milliseconds} from '@store/@types/util';

export interface CreateToastInterface {
  type: 'success' | 'error';
  time: Milliseconds;
  message: string;
  onClick: Func;
  dismissible: boolean;
  position: 'top-center' | 'bottom-right';
}

export class Toast extends Data<CreateToastInterface & {id: Int}>({
  id: null,
  type: 'success',
  time: 5000,
  message: '',
  onClick: undefined,
  dismissible: false,
  position: 'bottom-right',
}) {}
